import { BillingReport } from 'common/api/v1/types'

import { BillingRequestParams } from '../nm-types'
import { EdgeClient } from 'common/generated/edgeClient'

export class BillingApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  readBilling(params: BillingRequestParams): Promise<BillingReport> {
    return this.edgeClient.getBillingReport({
      startDate: params.startDate.toISOString(),
      endDate: params.endDate.toISOString(),
    })
  }
}
